<template lang="pug">
  transition(name="fade")
    div(v-show="isInit" :class="getClass()")
      .search
        .ttl-select(v-if="type!=='event'")
          .ttl
            h2 {{myData.title}}
            p {{myData.desc}}
          .select-area
            div
              label {{myData.tag}}
              .select-box
                select.sort1(v-model="selected['0']")
                  option(value="0") すべて
                  option(v-for="c0 in common[0]" :value="c0.term_id")
                    | {{ c0.name }}
                span
            div
              label {{myData.cat}}
              .select-box
                select.sort2(v-model="selected['1']")
                  option(value="0") すべて
                  option(v-for="c1 in common[1]" :value="c1.term_id")
                    | {{ c1.name }}
                span
            .search-btn
              input.alp(type="submit" value="検索"  @click.prevent.stop="onClickSubmit(0)")
        .ttl-select(v-else)
          .ttl
            h2 {{myData.title}}
            p {{myData.desc}}
          .select-area
            div
              label {{myData.cat}}
              .select-box
                select.sort2(v-model="selected['1']")
                  option(value="0") すべて
                  option(v-for="c1 in common[1]" :value="c1.term_id")
                    | {{ c1.name }}
                span
            div
              label {{myData.tag}}
              .select-box
                select.sort1(v-model="selected['0']")
                  option(value="0") すべて
                  option(v-for="c0 in common[0]" :value="c0.term_id")
                    | {{ c0.name }}
                span
            .search-btn
              input.alp(type="submit" value="検索"  @click.prevent.stop="onClickSubmit(0)")
        .card-area
          template(v-if="common && common[0] && common[0].length && common[1] && common[1].length && data && data.posts && data.posts.length")
            Card(:type="type" :key="dt.ID" :data="dt", v-for="(dt, i) in data.posts", :currentTab.sync=currentTab, :tab="0", :commonData="common")
            Card(v-if="!((data.posts.length - 2) % 3)" :isDummy="true")
          div.none(v-else-if="isInit && data.isBusy === false")
            | 該当するものがございませんでした。
            br
            | 他のキーワードで再度お試しください。
        .more(v-if="data && data.paged && data.paged !== data.max_num_pages && data.max_num_pages")
          a.alp(@click="onClickMore()")
            span もっと見る
</template>

<style lang="scss" scoped>
.busy {
  transition: 0.1s opacity ease-in;
  .card-area,
  .select-area {
    transition: 0.1s opacity ease-in;
    opacity: 0.5;
  }
}
a {
  cursor: pointer;
}

@mixin flex($jc: space-between) {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  justify-content: $jc;
}

$concour: #00a8ff;
$teaching: #f99709;
$event: #2eb024;

$white-border: 0 2px 1px #fff, 2px 0 1px #fff, 0 -2px 1px #fff, -2px 0 1px #fff,
  -2px -2px 1px #fff, 2px -2px 1px #fff, -2px 2px 1px #fff, 2px 2px 1px #fff;

// 色
.concour {
  .search {
    .ttl-select {
      h2 {
        -webkit-transform: perspective(1);
        color: $concour;
      }
      .select-area {
        > div:not(.search-btn) {
          label {
            -webkit-transform: perspective(1);
            color: $concour;
          }
          span {
            background-color: $concour;
            letter-spacing: 0;
          }
        }
        input {
          background-color: $concour;
        }
      }
    }
    .more {
      a {
        color: $concour;
        border: 3px solid $concour;
      }
      span:before,
      span:after {
        background: $concour;
      }
    }
    @media only screen and (max-width: 750px) {
      .more {
        border: 1.5px solid $concour;
      }
      .ttl-select {
        h2 {
          background-image: url(../../assets/img/common/ico_concour_sp.png);
        }
      }
    }
  }
}
.teaching {
  .search {
    .ttl-select {
      h2 {
        color: $teaching;
      }
      .select-area {
        > div:not(.search-btn) {
          label {
            color: $teaching;
          }
          span {
            background-color: $teaching;
            letter-spacing: 0;
          }
        }
        input {
          background-color: $teaching;
        }
      }
    }
    .more {
      a {
        color: $teaching;
        border: 3px solid $teaching;
      }
      span:before,
      span:after {
        background: $teaching;
      }
    }
    @media only screen and (max-width: 750px) {
      .more {
        border: 1.5px solid $teaching;
      }
      .ttl-select {
        h2 {
          background-image: url(../../assets/img/common/ico_teaching_sp.png);
        }
      }
    }
  }
}
.event {
  .search {
    .ttl-select {
      h2 {
        color: $event;
      }
      .select-area {
        > div:not(.search-btn) {
          label {
            color: $event;
          }
          span {
            background-color: $event;
            letter-spacing: 0;
          }
        }
        input {
          background-color: $event;
        }
      }
    }
    .more {
      a {
        color: $event;
        border: 3px solid $event;
      }
      span:before,
      span:after {
        background: $event;
      }
    }
    @media only screen and (max-width: 750px) {
      .more {
        border: 1.5px solid $event;
      }
      .ttl-select {
        h2 {
          padding-left: 7vw;
          display: inline-block;
          letter-spacing: 0.05em;
          background-repeat: no-repeat;
          background-size: 6vw auto;
          background-position: 0;
          line-height: 1.4;
          font-size: 2.14rem;
          background-image: url(../../assets/img/common/ico_event_sp.png);
        }
      }
    }
  }
}

.search {
  min-height: 500px;
  .inner {
    max-width: 1000px;
    box-sizing: border-box;
    margin: 0 auto;
    padding: 0 10px;
  }
  .ttl-select {
    margin: 85px 0 60px;
    @include flex();
    h2 {
      font-size: 34px;
      color: $concour;
      font-weight: bold;
      text-shadow: $white-border;
    }
    p {
      font-size: 14px;
      font-weight: bold;
      text-shadow: $white-border;
      margin: 18px 0 0;
      letter-spacing: 0.15em;
    }
    .select-area {
      width: 60.21%;
      > div:not(.search-btn) {
        width: 39%;
        label {
          margin-bottom: 12px;
        }
        span {
          letter-spacing: 0;
        }
      }
    }
  }
  .card-area {
    flex-wrap: wrap;
    min-height: 351px;
    position: relative;
    .none {
      position: absolute;
      
      background-color: #ffffff;
      font-size: 18px;
      line-height: 1.7;
      text-align: center;
      width: 100%;
      padding-top: 100px;
      padding-bottom: 100px;
      padding-left: 5%;
      padding-right: 5%;
      color: #333333;
    }
    @media only screen and (max-width: 1000px) {
    }
    @media only screen and (max-width: 750px) {
      min-height: 246px;
      .none {
        font-size: 14px;
      }
    }
  }
  .more {
    width: 39.4%;
    margin: 56px auto 0;
    font-size: 15px;
    a {
      color: $concour;
      border: 3px solid $concour;
    }
    span {
      padding-left: 21px;
    }
    span:before,
    span:after {
      content: " ";
      display: block;
      border-radius: 2px;
      background: $concour;
      position: absolute;
    }
    span:before {
      top: 50%;
      left: 0;
      width: 3px;
      height: 19px;
      -webkit-transform: translate(-50%, -50%);
      -ms-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
    }
    span:after {
      top: 50%;
      left: 0;
      width: 19px;
      height: 3px;
      -webkit-transform: translate(-50%, -50%);
      -ms-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
    }
  }
  @media only screen and (max-width: 750px) {
    $white-border2: 0 1px 1px #fff, 1px 0 1px #fff, 0 -1px 1px #fff,
      -1px 0 1px #fff, -1px -1px 1px #fff, 1px -1px 1px #fff, -1px 1px 1px #fff,
      1px 1px 1px #fff;
    .inner {
      padding: 0;
    }
    .ttl-select {
      display: block;
      margin: 9.4vw 0 9.4vw;
      .ttl {
        margin-bottom: 8vw;
        text-align: center;
      }
      h2 {
        padding-left: 12.5vw;
        display: inline-block;
        letter-spacing: 0.08em;
        background-repeat: no-repeat;
        background-size: 11vw auto;
        background-position: center left;
        line-height: 1.4;

        font-size: 2.14rem;
      }
      p {
        margin-top: 3vw;
        font-size: 0.94rem;
        letter-spacing: 0.1em;
        text-shadow: $white-border2;
      }
      .select-area {
        flex-wrap: wrap;
        width: 100%;
        > div:not(.search-btn) {
          width: 48.5%;
        }
        label {
          color: $concour;
        }
        span {
          background: $concour;
        }
        input {
          width: 100%;
          background-color: $concour;
        }
      }
      .card-area {
        display: block;
        .card {
          width: 100%;
        }
      }
    }

    .more {
      width: 100%;
      margin: 8vw auto 2vw;
      border: 1.5px solid $concour;
      font-size: 1.28rem;
      span {
        padding-left: 4.7vw;
        &:before {
          width: 0.78vw;
          height: 4.285vw;
        }
        &:after {
          width: 4.285vw;
          height: 0.78vw;
        }
      }
    }
  }
}
</style>

<script>
import Card from "./CardRouterLink";
export default {
  data: () => {
    return {
      isInit: false,
      selected: { "0": 0, "1": 0 },
      searchSelected: { "0": 0, "1": 0 },
      isBusy: false,
      eachData: {
        concour: {
          title: "コンクール応募情報",
          desc: "現在応募できるコンクール情報を紹介します。",
          cat: "カテゴリから探す",
          tag: "学年から探す"
        },
        teaching: {
          title: "教材情報",
          desc: "教育現場で活用できる教材について紹介します。",
          cat: "カテゴリから探す",
          tag: "学年から探す"
        },
        event: {
          title: "イベント情報",
          desc: "全国各地で行われるイベントについて紹介します。",
          cat: "開催月から探す",
          tag: "エリアから探す"
        }
      }
    };
  },
  props: ["type"],
  computed: {
    myData() {
      return this.eachData[this.type];
    },
    data() {
      return this.$store.state.data[`${this.type}Search`];
    },
    commonData() {
      return this.$store.state.data.searchCommon || {};
    },
    common() {
      switch (this.type) {
        case "concour":
          return this.commonConcour;
        case "teaching":
          return this.commonTeaching;
        case "event":
          return this.commonEvent;
      }
    },
    commonConcour() {
      return [
        this.commonData["concour_age"],
        this.commonData["concour_category"]
      ];
    },
    commonTeaching() {
      return [
        this.commonData["teaching_age"],
        this.commonData["teaching_category"]
      ];
    },
    commonEvent() {
      return [this.commonData["event_area"], this.commonData["event_date"]];
    }
  },
  updated() {
    if (!this.isInit && this.data && this.data.posts) {
      this.isInit = true;
    }
  },
  methods: {
    onClickMore() {
      this.fetchData();
    },
    onClickSubmit() {
      location.search = `cats=${this.selected[1]}&tags=${this.selected[0]}`;
    },
    fetchData() {
      this.$store.dispatch("fetchDataPaging", {
        url: "wp-json/custom/search",
        key: this.type + "Search",
        name: `${this.type}/${this.selected[1]}/${this.selected[0]}`
      });
    },
    getClass() {
      const obj = {};
      obj[this.type] = true;
      obj.busy = this.data.isBusy === true;
      return obj;
    }
  },
  components: {
    Card
  },
  created() {
    this.$store.dispatch("fetchData", {
      url: "wp-json/custom/search-common",
      key: "searchCommon"
    });
    const q = this.$route.query;
    this.selected["1"] = this.searchSelected["1"] = Number(q.cats) || 0;
    this.selected["0"] = this.searchSelected["0"] = Number(q.tags) || 0;
    if (!this.data || !this.data.posts) {
      this.fetchData();
    }
  }
};
</script>
